// extracted by mini-css-extract-plugin
export default {"container":"styles_container__JDpl7","loader":"styles_loader__Gzz-F","spin":"styles_spin__jeeTC"};